import http from "./http";

//获取反馈列表
export const getFeedBackList = async (data) => {
    return await http.get(`/feedback/getFeedbackList`, data);
};